import React from 'react';
import { RequestInformationPage } from './RequestInformationPage';

// /request-information/v3 — same streamlined question set and lead handling
// as the v1 template, presented in a single persistent card beside the
// marketing copy, with its own header and footer.
export function RequestInformationV3Page() {
  return <RequestInformationPage variant="v3" layout="split-card" content={{
    metaTitle: 'Find Your Perfect Online Degree | FindOnlineDegrees',
    metaDescription: 'Get matched with accredited online degree programs tailored to your goals. Compare schools and explore financial aid.',
    badge: 'Trusted by 70,000+ Students',
    headline: 'Find Your Perfect',
    headlineAccent: 'Online Degree',
    subhead: 'Get matched with accredited programs tailored to your goals. Compare schools, explore financial aid, and start your next chapter today.',
    features: ['Accredited institutions only', 'Financial aid guidance', 'Personalized program matches', 'No cost, no obligation']
  }} data-id="element-1907" data-mp="3u229hmy9dnvr" />;
}